import React, { useState } from 'react';
import { Button, IconButton, Tooltip } from '@material-ui/core';

import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';

import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { useSnackbar } from 'notistack';
import organizationService from '@/service/organizationService';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import {
    closePanelTabSelector,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { userAtom } from '@/state/atom/userAtom';

export default function GroupActionBlockAndDeleteCorporation({ organizationDetail, ...props }) {
    const { enqueueSnackbar } = useSnackbar();
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const currentUserDetail = useRecoilValue(userAtom);
    const [isOpenPopupConfirmBlock, setIsPopupConfirmBlock] = useState(false);
    const [isOpenPopupConfirmUnlock, setIsPopupConfirmUnlock] = useState(false);
    const [isOpenPopupConfirmDelete, setIsOpenPopupConfirmDelete] = useState(false);
    const [isOpenPopupCantNotDelete, setIsOpenPopupCantNotDelete] = useState(false);

    const onClickBlockOrg = () => {
        setIsPopupConfirmBlock(true);
    };

    const onClickUnlockOrg = () => {
        setIsPopupConfirmUnlock(true);
    };

    const onClickDeleteOrg = id => {
        setIsOpenPopupConfirmDelete(true);
    };

    const onSubmitUnlockOrg = async () => {
        try {
            setIsPopupConfirmUnlock(false);
            props.setIsLoading(true);
            await organizationService.blockAndDeleteOrg(
                props?.API,
                organizationDetail.id,
                Constant.ORG_ACTION.UNLOCK,
                currentUserDetail?.id
            );
            enqueueSnackbar(I18n.get('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            props.setIsLoading(false);
            reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
            props.setTriggerReload(Date.now().toString());
        } catch (err) {
            props.setIsLoading(false);
        }
    };

    const onSubmitBlockOrg = async () => {
        try {
            setIsPopupConfirmBlock(false);
            props.setIsLoading(true);
            await organizationService.blockAndDeleteOrg(
                props?.API,
                organizationDetail.id,
                Constant.ORG_ACTION.BLOCK,
                currentUserDetail?.id
            );
            enqueueSnackbar(I18n.get('COMMSG045'), {
                variant: 'success',
                autoHideDuration: 3000
            });
            props.setIsLoading(false);
            reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
            props.setTriggerReload(Date.now().toString());
        } catch (err) {
            props.setIsLoading(false);
        }
    };

    const onSubmitDeleteOrg = async () => {
        setIsOpenPopupConfirmDelete(false);
        props.setIsLoading(true);
        const deleteResult = await organizationService.blockAndDeleteOrg(
            props?.API,
            organizationDetail.id,
            'DELETE'
        );
        if (!deleteResult.success) {
            setIsOpenPopupCantNotDelete(true);
            props.setIsLoading(false);
            return;
        }
        enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        reloadTicketListByPanelType({ panelType: Constant.PANEL_TYPE.ROOT_LIST_ORG });
        closePanelTab({
            event: null,
            panelType: Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT,
            panelId: props.panelId,
            tabId: props.tabId
        });
        props.setIsLoading(false);
    };

    return (
        <>
            <div
                className="head-btn"
                style={{
                    width: '100%',
                    padding: '0px 0px 0px 0px',
                    height: '40px'
                }}
            >
                <div
                    className="titleTicket"
                    style={{
                        width: '100%',
                        padding: '6px 16px 0px 16px'
                    }}
                >
                    <OverFlowTooltipWithTabsMui className="titleDisplay titleTicket-titlev2" value={organizationDetail?.name} />

                    <div className="titleTicket-btn titleTicket-btn-edit-org">
                        {organizationDetail.rootFlag !== 1 && (
                            <>
                                {organizationDetail.active ===
                                    Constant.CORPORATION_ACTIVE.ACTIVE && (
                                    <Tooltip title="運用停止">
                                        <div className="btnItem">
                                            <IconButton
                                                onClick={onClickBlockOrg}
                                                className="itemNav"
                                                data-cy="detail-ticket-icon-chat"
                                            >
                                                <img src="/assets/image/block-icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                )}

                                {[
                                    Constant.CORPORATION_ACTIVE.REJECT,
                                    Constant.CORPORATION_ACTIVE.WAITING_APPROVE
                                ].includes(organizationDetail.active) && (
                                    <Tooltip title="運用停止">
                                        <Button className="groupBtnOrgInCorp" disabled={true}>
                                            <img src="/assets/image/block-ico-disable.svg" alt="" />
                                        </Button>
                                    </Tooltip>
                                )}

                                {organizationDetail.active ===
                                    Constant.CORPORATION_ACTIVE.BLOCK && (
                                    <>
                                        <Tooltip title="停止解除">
                                            <div className="btnItem">
                                                <IconButton
                                                    className="itemNav"
                                                    data-cy="detail-ticket-icon-chat"
                                                    onClick={onClickUnlockOrg}
                                                >
                                                    <img
                                                        src="/assets/image/unlock-icon.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            </div>
                                        </Tooltip>
                                        <Tooltip title="削除">
                                            <div className="btnItem">
                                                <IconButton
                                                    onClick={onClickDeleteOrg}
                                                    className="itemNav"
                                                    data-cy="detail-ticket-icon-knowledge"
                                                >
                                                    <img
                                                        src="/assets/image/delete-icon.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            </div>
                                        </Tooltip>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <ConfirmDialog
                isOpen={isOpenPopupConfirmBlock}
                msgConfirm={I18n.get('USER14MSG002')}
                closeCallBack={() => {
                    setIsPopupConfirmBlock(false);
                }}
                okCallBack={onSubmitBlockOrg}
                textSubmit="はい"
                textClose="いいえ"
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmUnlock}
                msgConfirm={I18n.get('USER14MSG003')}
                closeCallBack={() => {
                    setIsPopupConfirmUnlock(false);
                }}
                okCallBack={onSubmitUnlockOrg}
                textSubmit="はい"
                textClose="いいえ"
            />
            <ConfirmDialog
                isOpen={isOpenPopupConfirmDelete}
                msgConfirm={I18n.get('USER14MSG001')}
                closeCallBack={() => {
                    setIsOpenPopupConfirmDelete(false);
                }}
                okCallBack={onSubmitDeleteOrg}
                textSubmit="はい"
                textClose="いいえ"
            />
            <ConfirmDialog
                isOpen={isOpenPopupCantNotDelete}
                msgConfirm={I18n.get('USER14MSG001-1')}
                okCallBack={() => {
                    setIsOpenPopupCantNotDelete(false);
                }}
                textSubmit="はい"
                textClose="いいえ"
            />
        </>
    );
}
